import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { IoIosClose } from 'react-icons/io';
import styles from './styles.scss';

export class CardReviewMessageModal extends React.Component {
    el = document.createElement('div');

    static propTypes = {
        closeModalFn: PropTypes.func.isRequired,
        children: PropTypes.any.isRequired,
    };

    componentDidMount() {
        const modalRoot = document.getElementById('cardRoot');
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        const modalRoot = document.getElementById('cardRoot');
        modalRoot.removeChild(this.el);
    }

    render() {
        const { closeModalFn, children } = this.props;

        return ReactDOM.createPortal(
            <div className={styles.root}>
                <div className={styles.pane}>
                    {children}
                    <span className={styles.closeButton} onClick={closeModalFn}>
                        <IoIosClose size={32} color="#000" />
                    </span>
                </div>
            </div>,
            this.el
        );
    }
}
